import { ProgressBar } from '@opendoor/bricks/complex';
import { Flex } from '@opendoor/bricks/core';

import { useAppSelector } from 'src/store/hooks';
import { progressPercentage as getProgressPercentage } from 'src/store/sellerFlow/selectors';

export const ProgressIndicator = () => {
  const progressPercentage = useAppSelector(getProgressPercentage);
  /* The extra 2vw cuts off the border radius */
  return (
    <Flex minWidth="102vw">
      <ProgressBar
        progress={progressPercentage}
        gradientProgress={false}
        colorStart="#0040E6" // 'brand50' wasn't working
        thickness={5}
      />
    </Flex>
  );
};
